import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a6d0fe6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "card border mb-10 intro" }
const _hoisted_3 = { class: "mt-5 t-blanco fs-1" }
const _hoisted_4 = {
  key: 0,
  class: "row mb-10"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "image-container" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "overlay" }
const _hoisted_9 = { class: "vertical-text" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "fs-2 fw-bold" }
const _hoisted_12 = { class: "fs-4" }
const _hoisted_13 = {
  key: 0,
  class: "my-3"
}
const _hoisted_14 = {
  key: 0,
  class: "badge badge-primary me-5 mt-2"
}
const _hoisted_15 = {
  key: 1,
  class: "badge badge-success me-5 mt-2"
}
const _hoisted_16 = {
  key: 2,
  class: "badge badge-poblacion-general me-5 mt-2"
}
const _hoisted_17 = {
  key: 3,
  class: "badge badge-profesionales me-5 mt-2"
}
const _hoisted_18 = {
  key: 4,
  class: "badge badge-empresas me-5 mt-2"
}
const _hoisted_19 = {
  key: 5,
  class: "badge badge-mujeres-orientacion-empleo me-5 mt-2"
}
const _hoisted_20 = {
  key: 6,
  class: "badge badge-emprendedoras-asociaciones me-5 mt-2"
}
const _hoisted_21 = {
  key: 7,
  class: "badge badge-emprendedoras me-5 mt-2"
}
const _hoisted_22 = { class: "row mt-5 ms-0" }
const _hoisted_23 = { class: "col-md-3 col-sm-4 card border border-dark border-dashed text-center p-2 me-3 mb-2" }
const _hoisted_24 = { class: "text-muted fw-bold" }
const _hoisted_25 = { class: "fw-bold" }
const _hoisted_26 = { class: "col-md-3 col-sm-4 card border border-dark border-dashed text-center p-2 me-3 mb-2" }
const _hoisted_27 = { class: "text-muted fw-bold" }
const _hoisted_28 = { class: "fw-bold" }
const _hoisted_29 = { class: "col-md-5 col-sm-4 card border border-dark border-dashed text-center p-2 me-3 mb-2" }
const _hoisted_30 = { class: "text-muted fw-bold" }
const _hoisted_31 = { class: "fw-bold" }
const _hoisted_32 = { class: "fw-bold mt-3" }
const _hoisted_33 = { class: "text-muted" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { key: 3 }
const _hoisted_38 = {
  key: 1,
  class: "fw-bold mt-3"
}
const _hoisted_39 = {
  key: 2,
  class: "fw-bold mt-3"
}
const _hoisted_40 = {
  key: 1,
  class: "card border textoCentrado mt-3 mb-10 fs-3 text-muted"
}
const _hoisted_41 = { class: "my-10" }
const _hoisted_42 = { class: "card border mb-10 faqs" }
const _hoisted_43 = { class: "card border mb-10 contacto" }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "card border mb-10" }
const _hoisted_46 = { class: "card-body p-10" }
const _hoisted_47 = { class: "row align-items-center desktop" }
const _hoisted_48 = { class: "col-12" }
const _hoisted_49 = { class: "image-container-grande" }
const _hoisted_50 = ["src", "alt"]
const _hoisted_51 = { class: "overlay" }
const _hoisted_52 = { class: "vertical-text-grande" }
const _hoisted_53 = { class: "mt-5 fs-1 fw-bold" }
const _hoisted_54 = {
  key: 0,
  class: "my-3"
}
const _hoisted_55 = {
  key: 0,
  class: "badge badge-primary me-5 mt-2"
}
const _hoisted_56 = {
  key: 1,
  class: "badge badge-success me-5 mt-2"
}
const _hoisted_57 = {
  key: 2,
  class: "badge badge-poblacion-general me-5 mt-2"
}
const _hoisted_58 = {
  key: 3,
  class: "badge badge-profesionales me-5 mt-2"
}
const _hoisted_59 = {
  key: 4,
  class: "badge badge-empresas me-5 mt-2"
}
const _hoisted_60 = {
  key: 5,
  class: "badge badge-mujeres-orientacion-empleo me-5 mt-2"
}
const _hoisted_61 = {
  key: 6,
  class: "badge badge-emprendedoras-asociaciones me-5 mt-2"
}
const _hoisted_62 = {
  key: 7,
  class: "badge badge-emprendedoras me-5 mt-2"
}
const _hoisted_63 = ["innerHTML"]
const _hoisted_64 = {
  key: 1,
  class: "mt-5 fs-3 fw-bold"
}
const _hoisted_65 = ["innerHTML"]
const _hoisted_66 = { class: "mt-5 fs-3 fw-bold" }
const _hoisted_67 = { class: "row mt-5 ms-0 align-items-center" }
const _hoisted_68 = { class: "col-md-2 col-sm-4 card border border-dark border-dashed text-center p-2 me-3 mb-2" }
const _hoisted_69 = { class: "text-muted fw-bold" }
const _hoisted_70 = { class: "fw-bold fs-3" }
const _hoisted_71 = { class: "col-md-2 col-sm-4 card border border-dark border-dashed text-center p-2 me-3 mb-2" }
const _hoisted_72 = { class: "text-muted fw-bold" }
const _hoisted_73 = { class: "fw-bold fs-3" }
const _hoisted_74 = { class: "col-md-3 col-sm-4 card border border-dark border-dashed text-center p-2 me-3 mb-2" }
const _hoisted_75 = { class: "text-muted fw-bold" }
const _hoisted_76 = { class: "fw-bold fs-3" }
const _hoisted_77 = { class: "col-md-12 col-sm-4 card p-2 me-3 mb-2" }
const _hoisted_78 = { class: "fw-bold mt-3 fs-3" }
const _hoisted_79 = { class: "text-muted" }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { key: 1 }
const _hoisted_82 = { key: 2 }
const _hoisted_83 = { key: 3 }
const _hoisted_84 = { class: "mt-3" }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = {
  key: 0,
  class: "card border mb-10"
}
const _hoisted_87 = { class: "card-body p-10" }
const _hoisted_88 = { class: "row align-items-center desktop" }
const _hoisted_89 = { class: "fs-1 fw-bold" }
const _hoisted_90 = { class: "mt-2 mb-10 fs-4" }
const _hoisted_91 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_92 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_93 = { class: "col-lg-8 fv-row" }
const _hoisted_94 = { class: "row" }
const _hoisted_95 = { class: "fv-plugins-message-container" }
const _hoisted_96 = { class: "fv-help-block" }
const _hoisted_97 = { key: 1 }
const _hoisted_98 = { class: "text-center fs-3" }
const _hoisted_99 = { class: "row mb-6" }
const _hoisted_100 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_101 = { class: "col-lg-8 fv-row" }
const _hoisted_102 = { class: "row" }
const _hoisted_103 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_104 = { class: "fv-plugins-message-container" }
const _hoisted_105 = { class: "fv-help-block" }
const _hoisted_106 = { class: "row mb-6" }
const _hoisted_107 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_108 = { class: "col-lg-8 fv-row" }
const _hoisted_109 = { class: "row" }
const _hoisted_110 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_111 = { class: "fv-plugins-message-container" }
const _hoisted_112 = { class: "fv-help-block" }
const _hoisted_113 = { class: "row mb-6" }
const _hoisted_114 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_115 = { class: "col-lg-8 fv-row" }
const _hoisted_116 = { class: "row" }
const _hoisted_117 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_118 = { class: "fv-plugins-message-container" }
const _hoisted_119 = { class: "fv-help-block" }
const _hoisted_120 = { class: "row mb-6" }
const _hoisted_121 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_122 = { class: "col-lg-8 fv-row" }
const _hoisted_123 = { class: "row" }
const _hoisted_124 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_125 = { class: "fv-plugins-message-container" }
const _hoisted_126 = { class: "fv-help-block" }
const _hoisted_127 = { class: "row mb-6" }
const _hoisted_128 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_129 = { class: "col-lg-8 fv-row" }
const _hoisted_130 = { class: "row" }
const _hoisted_131 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_132 = { class: "fv-plugins-message-container" }
const _hoisted_133 = { class: "fv-help-block" }
const _hoisted_134 = { class: "text-center fs-3" }
const _hoisted_135 = { key: 2 }
const _hoisted_136 = { class: "row mb-6" }
const _hoisted_137 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_138 = { class: "col-lg-8 fv-row" }
const _hoisted_139 = { class: "row" }
const _hoisted_140 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_141 = { class: "fv-plugins-message-container" }
const _hoisted_142 = { class: "fv-help-block" }
const _hoisted_143 = { class: "row mb-6" }
const _hoisted_144 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_145 = { class: "col-lg-8 fv-row" }
const _hoisted_146 = { class: "row" }
const _hoisted_147 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_148 = { class: "fv-plugins-message-container" }
const _hoisted_149 = { class: "fv-help-block" }
const _hoisted_150 = { class: "row mb-6" }
const _hoisted_151 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_152 = { class: "col-lg-8 fv-row" }
const _hoisted_153 = { class: "row" }
const _hoisted_154 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_155 = { class: "fv-plugins-message-container" }
const _hoisted_156 = { class: "fv-help-block" }
const _hoisted_157 = { class: "row mb-6" }
const _hoisted_158 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_159 = { class: "col-lg-8 fv-row" }
const _hoisted_160 = { class: "row" }
const _hoisted_161 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_162 = { class: "fv-plugins-message-container" }
const _hoisted_163 = { class: "fv-help-block" }
const _hoisted_164 = { class: "row mb-6" }
const _hoisted_165 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_166 = { class: "col-lg-8 fv-row" }
const _hoisted_167 = { class: "row" }
const _hoisted_168 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_169 = { class: "fv-plugins-message-container" }
const _hoisted_170 = { class: "fv-help-block" }
const _hoisted_171 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle me-1 text-warning" }, null, -1))
const _hoisted_173 = { class: "row mb-6" }
const _hoisted_174 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_175 = { class: "col-lg-8 fv-row" }
const _hoisted_176 = { class: "row" }
const _hoisted_177 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_178 = { class: "fv-plugins-message-container" }
const _hoisted_179 = { class: "fv-help-block" }
const _hoisted_180 = { class: "row mb-6" }
const _hoisted_181 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_182 = { class: "col-lg-8 fv-row" }
const _hoisted_183 = { class: "row" }
const _hoisted_184 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_185 = { class: "fv-plugins-message-container" }
const _hoisted_186 = { class: "fv-help-block" }
const _hoisted_187 = { class: "row mb-6" }
const _hoisted_188 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_189 = { class: "col-lg-8 fv-row" }
const _hoisted_190 = { class: "row" }
const _hoisted_191 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_192 = { class: "fv-plugins-message-container" }
const _hoisted_193 = { class: "fv-help-block" }
const _hoisted_194 = { class: "row mb-6" }
const _hoisted_195 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_196 = { class: "col-lg-8 fv-row" }
const _hoisted_197 = { class: "row" }
const _hoisted_198 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_199 = { class: "fv-plugins-message-container" }
const _hoisted_200 = { class: "fv-help-block" }
const _hoisted_201 = { class: "row mb-6" }
const _hoisted_202 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_203 = { class: "col-lg-8 fv-row" }
const _hoisted_204 = { class: "row" }
const _hoisted_205 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_206 = { class: "fv-plugins-message-container" }
const _hoisted_207 = { class: "fv-help-block" }
const _hoisted_208 = { class: "row mb-6" }
const _hoisted_209 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_210 = { class: "col-lg-8 fv-row" }
const _hoisted_211 = { class: "row" }
const _hoisted_212 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_213 = { class: "fv-plugins-message-container" }
const _hoisted_214 = { class: "fv-help-block" }
const _hoisted_215 = {
  key: 3,
  class: "fw-bold text-center fs-4"
}
const _hoisted_216 = { class: "row mb-6" }
const _hoisted_217 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_218 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_219 = {
  key: 1,
  class: "col-lg-8 fs-5 mt-lg-3"
}
const _hoisted_220 = {
  key: 4,
  class: "row mb-6"
}
const _hoisted_221 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_222 = { class: "col-lg-8 fv-row" }
const _hoisted_223 = { class: "row" }
const _hoisted_224 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_225 = { class: "fv-plugins-message-container" }
const _hoisted_226 = { class: "fv-help-block" }
const _hoisted_227 = {
  key: 5,
  class: "row mb-6"
}
const _hoisted_228 = { class: "col-lg-4 col-form-label fs-6 text-lg-end" }
const _hoisted_229 = { class: "col-lg-8 fv-row" }
const _hoisted_230 = { class: "row" }
const _hoisted_231 = { class: "col-lg-7 fv-row fv-plugins-icon-container" }
const _hoisted_232 = { class: "row" }
const _hoisted_233 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label" }, null, -1))
const _hoisted_234 = { class: "col-lg-8 fv-row form-check form-check-custom form-check-solid" }
const _hoisted_235 = { class: "form-check-label" }
const _hoisted_236 = {
  type: "button",
  class: "btn btn-active-light-primary botonPrivacidad",
  "data-bs-toggle": "modal",
  "data-bs-target": "#condiciones-privacidad"
}
const _hoisted_237 = { class: "row mb-6" }
const _hoisted_238 = { class: "col-lg-8 offset-lg-4" }
const _hoisted_239 = { class: "my-6 row justify-content-center" }
const _hoisted_240 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Intro = _resolveComponent("Intro")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")!
  const _component_FAQs = _resolveComponent("FAQs")!
  const _component_Contacto = _resolveComponent("Contacto")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_BIconBuilding = _resolveComponent("BIconBuilding")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_BIconPersonVcard = _resolveComponent("BIconPersonVcard")!
  const _component_BIconEasel = _resolveComponent("BIconEasel")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CondicionesPrivacidadModal = _resolveComponent("CondicionesPrivacidadModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.datosCurso)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Intro, {
              "header-image": _ctx.homeHeaderImage,
              "intro-html": _ctx.homeIntroHtml,
              "pdf-resumen": _ctx.homePdfResumen,
              "pdf-resumen-name": _ctx.homePdfResumenName,
              "pdf-programa": _ctx.homePdfPrograma,
              "pdf-programa-name": _ctx.homePdfProgramaName
            }, null, 8, ["header-image", "intro-html", "pdf-resumen", "pdf-resumen-name", "pdf-programa", "pdf-programa-name"])
          ]),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("listadoCursos")), 1),
          (_ctx.datosCursos.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datosCursos, (curso) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-md-12 col-lg-6 my-3",
                    key: curso.id
                  }, [
                    _createElementVNode("div", {
                      class: "card border",
                      style: {"cursor":"pointer"},
                      onClick: ($event: any) => (_ctx.onItemTap(curso))
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("img", {
                          src: curso.imagen,
                          alt: curso.nombre,
                          class: "background-image"
                        }, null, 8, _hoisted_7),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(curso.areaTematica), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(curso.nombre), 1),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(curso.descripcionCorta), 1),
                        (curso.presencial || curso.videoconferencia)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              (curso.presencial)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t("cursoPresencial")), 1))
                                : _createCommentVNode("", true),
                              (curso.videoconferencia)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t("cursoVideoconferencia")), 1))
                                : _createCommentVNode("", true),
                              (curso.badges.includes('POBLACION_GENERAL'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t("etiquetaPoblacionGeneral")), 1))
                                : _createCommentVNode("", true),
                              (curso.badges.includes('PROFESIONAL'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t("etiquetaProfesionales")), 1))
                                : _createCommentVNode("", true),
                              (curso.badges.includes('EMPRESA'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t("etiquetaEmpresas")), 1))
                                : _createCommentVNode("", true),
                              (curso.badges.includes('MUJERES_ORIENTACION_EMPLEO'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t("etiquetaMujeresOrientacionEmpleo")), 1))
                                : _createCommentVNode("", true),
                              (curso.badges.includes('EMPRENDEDORAS_ASOCIACIONES'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t("etiquetaEmprendedorasAsociaciones")), 1))
                                : _createCommentVNode("", true),
                              (curso.badges.includes('EMPRENDEDORAS'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t("etiquetaEmprendedoras")), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("cursoFechaInicio")), 1),
                            _createElementVNode("div", _hoisted_25, _toDisplayString(new Date(curso.inicio)
                      .toLocaleDateString("es-ES", {
                        day: "2-digit",
                        month: "long",
                      })
                      .replace(/\s[0-9]{4}$/, "")), 1)
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("cursoFechaFin")), 1),
                            _createElementVNode("div", _hoisted_28, _toDisplayString(new Date(curso.fin)
                      .toLocaleDateString("es-ES", {
                        day: "2-digit",
                        month: "long",
                      })
                      .replace(/\s[0-9]{4}$/, "")), 1)
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("cursoHorario")), 1),
                            _createElementVNode("div", _hoisted_31, _toDisplayString(curso.horario), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("inscripciones")) + ": ", 1),
                          (new Date() < new Date(curso.inicioInscripciones))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.$t("fechaAPartirDe", {
                    inicioInscripciones: new Date(curso.inicioInscripciones)
                      .toLocaleDateString("es-ES", {
                        day: "2-digit",
                        month: "long",
                      })
                      .replace(/\s[0-9]{4}$/, ""),
                  })), 1))
                            : (
                  new Date() > new Date(curso.fin) ||
                  new Date() > new Date(curso.finInscripciones)
                )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t("inscripcionesCerradas")), 1))
                              : (curso.inscripcionesActivas >= curso.plazas)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.$t("plazasCompletas")), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.$t("percentPlazasOcupadas", {
                  plazasOcupadas: (
                    (curso.inscripcionesActivas / curso.plazas) *
                    100
                  ).toFixed(0),
                })), 1))
                        ]),
                        (
                new Date() < new Date(curso.fin) &&
                new Date() < new Date(curso.finInscripciones)
              )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              _createVNode(_component_el_progress, {
                                percentage: (curso.inscripcionesActivas / curso.plazas) * 100,
                                "stroke-width": 12,
                                "show-text": false
                              }, null, 8, ["percentage"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              _createVNode(_component_el_progress, {
                                percentage: 100,
                                "stroke-width": 12,
                                "show-text": false
                              })
                            ]))
                      ])
                    ], 8, _hoisted_5)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.loadingCursos
            ? _ctx.$t("cargandoCursos")
            : _ctx.errorCargandoCursos
            ? _ctx.$t("errorCargandoCursos")
            : _ctx.$t("sinCursos")), 1),
                (!_ctx.loadingCursos)
                  ? (_openBlock(), _createBlock(_component_Vue3Lottie, {
                      key: 0,
                      animationLink: "https://assets3.lottiefiles.com/packages/lf20_rc6CDU.json",
                      height: 200,
                      width: 200
                    }))
                  : _createCommentVNode("", true)
              ])),
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_FAQs, {
              "faqs-cursos": _ctx.homeFaqsCursos,
              "faqs-iam": _ctx.homeFaqsIam
            }, null, 8, ["faqs-cursos", "faqs-iam"])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_component_Contacto)
          ])
        ])), [
          [_directive_loading, _ctx.loadingPagina]
        ])
      : (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("img", {
                      src: _ctx.datosCurso.imagen,
                      alt: _ctx.datosCurso.nombre,
                      class: "background-image rounded mx-auto d-block imagen-curso"
                    }, null, 8, _hoisted_50),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.datosCurso.areaTematica), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.datosCurso.nombre), 1),
                (_ctx.datosCurso.presencial || _ctx.datosCurso.videoconferencia)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                      (_ctx.datosCurso.presencial)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_ctx.$t("cursoPresencial")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.datosCurso.videoconferencia)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(_ctx.$t("cursoVideoconferencia")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.datosCurso.badges.includes('POBLACION_GENERAL'))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.$t("etiquetaPoblacionGeneral")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.datosCurso.badges.includes('PROFESIONAL'))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_ctx.$t("etiquetaProfesionales")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.datosCurso.badges.includes('EMPRESA'))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.$t("etiquetaEmpresas")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.datosCurso.badges.includes('MUJERES_ORIENTACION_EMPLEO'))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.$t("etiquetaMujeresOrientacionEmpleo")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.datosCurso.badges.includes('EMPRENDEDORAS_ASOCIACIONES'))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.$t("etiquetaEmprendedorasAsociaciones")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.datosCurso.badges.includes('EMPRENDEDORAS'))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.$t("etiquetaEmprendedoras")), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "mt-2 fs-4",
                  innerHTML: _ctx.datosCurso.descripcion ?? _ctx.datosCurso.descripcionCorta
                }, null, 8, _hoisted_63),
                (_ctx.stripTags(_ctx.datosCurso.personalDocente))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      _createTextVNode(_toDisplayString(_ctx.$t("personalDocente")) + ": ", 1),
                      _createElementVNode("div", {
                        class: "mt-2 ms-2 fs-4 fw-normal d-inline",
                        innerHTML: _ctx.datosCurso.personalDocente
                      }, null, 8, _hoisted_65)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.$t("informacionImportante")), 1),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$t("cursoFechaInicio")), 1),
                    _createElementVNode("div", _hoisted_70, _toDisplayString(new Date(_ctx.datosCurso.inicio)
                    .toLocaleDateString("es-ES", {
                      day: "2-digit",
                      month: "long",
                    })
                    .replace(/\s[0-9]{4}$/, "")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.$t("cursoFechaFin")), 1),
                    _createElementVNode("div", _hoisted_73, _toDisplayString(new Date(_ctx.datosCurso.fin)
                    .toLocaleDateString("es-ES", {
                      day: "2-digit",
                      month: "long",
                    })
                    .replace(/\s[0-9]{4}$/, "")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.$t("cursoHorario")), 1),
                    _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.datosCurso.horario), 1)
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.$t("inscripciones")) + ": ", 1),
                      (new Date() < new Date(_ctx.datosCurso.inicioInscripciones))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_80, _toDisplayString(_ctx.$t("fechaAPartirDe", {
                      inicioInscripciones: new Date(
                        _ctx.datosCurso.inicioInscripciones
                      )
                        .toLocaleDateString("es-ES", {
                          day: "2-digit",
                          month: "long",
                        })
                        .replace(/\s[0-9]{4}$/, ""),
                    })), 1))
                        : (
                    new Date() > new Date(_ctx.datosCurso.fin) ||
                    new Date() > new Date(_ctx.datosCurso.finInscripciones)
                  )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_81, _toDisplayString(_ctx.$t("inscripcionesCerradas")), 1))
                          : (
                    _ctx.datosCurso.inscripcionesActivas >= _ctx.datosCurso.plazas
                  )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(_ctx.$t("plazasCompletas")), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(_ctx.$t("percentPlazasOcupadas", {
                    plazasOcupadas: (
                      (_ctx.datosCurso.inscripcionesActivas / _ctx.datosCurso.plazas) *
                      100
                    ).toFixed(0),
                  })), 1))
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                      (
                    new Date() >= new Date(_ctx.datosCurso.inicioInscripciones) &&
                    _ctx.datosCurso.inscripcionesActivas < _ctx.datosCurso.plazas
                  )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_85, [
                            _createVNode(_component_el_progress, {
                              percentage: 
                      (_ctx.datosCurso.inscripcionesActivas / _ctx.datosCurso.plazas) *
                      100
                    ,
                              "stroke-width": 12,
                              "show-text": false
                            }, null, 8, ["percentage"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          (
        new Date() > new Date(_ctx.datosCurso.inicioInscripciones) &&
        new Date() < new Date(_ctx.datosCurso.finInscripciones)
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.$t("inscripcion")), 1),
                    _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.$t("introInscripcion")), 1),
                    (_ctx.perfilesAllowed.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                          _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.$t("formularios.inscripcion.perfil.label")), 1),
                          _createElementVNode("div", _hoisted_93, [
                            _createElementVNode("div", _hoisted_94, [
                              _createVNode(_component_el_radio_group, {
                                modelValue: _ctx.perfil,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.perfil) = $event)),
                                class: "ml-4"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.perfilesAllowed.includes('EMPRENDEDORA'))
                                    ? (_openBlock(), _createBlock(_component_el_radio, {
                                        key: 0,
                                        label: "EMPRENDEDORA",
                                        size: "large"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("formularios.inscripcion.perfilEmprendendora.label")), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.perfilesAllowed.includes('ASOCIACION'))
                                    ? (_openBlock(), _createBlock(_component_el_radio, {
                                        key: 1,
                                        label: "ASOCIACION",
                                        size: "large"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("formularios.inscripcion.perfilAsociacion.label")), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.perfilesAllowed.includes('POBLACION_GENERAL'))
                                    ? (_openBlock(), _createBlock(_component_el_radio, {
                                        key: 2,
                                        label: "POBLACION_GENERAL",
                                        size: "large"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("formularios.inscripcion.perfilEmprendendora.label")), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.perfilesAllowed.includes('PROFESIONAL'))
                                    ? (_openBlock(), _createBlock(_component_el_radio, {
                                        key: 3,
                                        label: "PROFESIONAL",
                                        size: "large"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("formularios.inscripcion.perfilProfesional.label")), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.perfilesAllowed.includes('EMPRESA'))
                                    ? (_openBlock(), _createBlock(_component_el_radio, {
                                        key: 4,
                                        label: "EMPRESA",
                                        size: "large"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("formularios.inscripcion.perfilAsociacion.label")), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_95, [
                                _createElementVNode("div", _hoisted_96, [
                                  _createVNode(_component_ErrorMessage, { name: "perfil" })
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.perfil === 'EMPRESA' || _ctx.perfil === 'ASOCIACION')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                          _createElementVNode("div", _hoisted_98, [
                            _createVNode(_component_BIconBuilding, {
                              style: {"font-size":"1.5rem"},
                              class: "me-3 my-5 mb-6"
                            }),
                            _createTextVNode(_toDisplayString(_ctx.$t("formularios.inscripcion.datosEmpresa.label")), 1)
                          ]),
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.$t("formularios.inscripcion.nombreEmpresa.label")), 1),
                            _createElementVNode("div", _hoisted_101, [
                              _createElementVNode("div", _hoisted_102, [
                                _createElementVNode("div", _hoisted_103, [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    name: "nombreEmpresa",
                                    placeholder: " ",
                                    modelValue: _ctx.nombreEmpresa,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nombreEmpresa) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_104, [
                                    _createElementVNode("div", _hoisted_105, [
                                      _createVNode(_component_ErrorMessage, { name: "nombreEmpresa" })
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_106, [
                            _createElementVNode("label", _hoisted_107, _toDisplayString(_ctx.$t("formularios.inscripcion.sectorEmpresa.label")), 1),
                            _createElementVNode("div", _hoisted_108, [
                              _createElementVNode("div", _hoisted_109, [
                                _createElementVNode("div", _hoisted_110, [
                                  _createVNode(_component_el_select_v2, {
                                    modelValue: _ctx.sectorEmpresa,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sectorEmpresa) = $event)),
                                    name: "sectorEmpresa",
                                    class: "w-100",
                                    options: _ctx.sectoresTodos,
                                    placeholder: 
                        _ctx.$t('listados.inscripcionDetalle.seleccionaUno')
                      
                                  }, null, 8, ["modelValue", "options", "placeholder"]),
                                  _createElementVNode("div", _hoisted_111, [
                                    _createElementVNode("div", _hoisted_112, [
                                      _createVNode(_component_ErrorMessage, { name: "sectorEmpresa" })
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_113, [
                            _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.$t("formularios.inscripcion.cifEmpresa.label")), 1),
                            _createElementVNode("div", _hoisted_115, [
                              _createElementVNode("div", _hoisted_116, [
                                _createElementVNode("div", _hoisted_117, [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    name: "cifEmpresa",
                                    placeholder: " ",
                                    modelValue: _ctx.cifEmpresa,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cifEmpresa) = $event)),
                                    onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cifEmpresa = _ctx.cifEmpresa.toUpperCase()))
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_118, [
                                    _createElementVNode("div", _hoisted_119, [
                                      _createVNode(_component_ErrorMessage, { name: "cifEmpresa" })
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_120, [
                            _createElementVNode("label", _hoisted_121, _toDisplayString(_ctx.$t("formularios.inscripcion.empleadosEmpresa.label")), 1),
                            _createElementVNode("div", _hoisted_122, [
                              _createElementVNode("div", _hoisted_123, [
                                _createElementVNode("div", _hoisted_124, [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    name: "empleadosEmpresa",
                                    placeholder: " ",
                                    modelValue: _ctx.empleadosEmpresa,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.empleadosEmpresa) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_125, [
                                    _createElementVNode("div", _hoisted_126, [
                                      _createVNode(_component_ErrorMessage, { name: "empleadosEmpresa" })
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_127, [
                            _createElementVNode("label", _hoisted_128, _toDisplayString(_ctx.$t("formularios.inscripcion.localidadEmpresa.label")), 1),
                            _createElementVNode("div", _hoisted_129, [
                              _createElementVNode("div", _hoisted_130, [
                                _createElementVNode("div", _hoisted_131, [
                                  _createVNode(_component_el_select_v2, {
                                    modelValue: _ctx.localidadEmpresa,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localidadEmpresa) = $event)),
                                    name: "localidadEmpresa",
                                    class: "w-100",
                                    options: _ctx.localidadesTodas,
                                    placeholder: 
                        _ctx.$t('listados.inscripcionDetalle.seleccionaUno')
                      
                                  }, null, 8, ["modelValue", "options", "placeholder"]),
                                  _createElementVNode("div", _hoisted_132, [
                                    _createElementVNode("div", _hoisted_133, [
                                      _createVNode(_component_ErrorMessage, { name: "localidadEmpresa" })
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_134, [
                      _createVNode(_component_BIconPersonVcard, {
                        style: {"font-size":"1.5rem"},
                        class: "me-3 my-5 mb-6"
                      }),
                      _createTextVNode(_toDisplayString(_ctx.$t("formularios.inscripcion.tusDatos.label")), 1)
                    ]),
                    (_ctx.perfil === 'PROFESIONAL')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                          _createElementVNode("div", _hoisted_136, [
                            _createElementVNode("label", _hoisted_137, _toDisplayString(_ctx.$t("formularios.inscripcion.entidad.label")), 1),
                            _createElementVNode("div", _hoisted_138, [
                              _createElementVNode("div", _hoisted_139, [
                                _createElementVNode("div", _hoisted_140, [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    name: "entidad",
                                    placeholder: " ",
                                    modelValue: _ctx.entidad,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.entidad) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_141, [
                                    _createElementVNode("div", _hoisted_142, [
                                      _createVNode(_component_ErrorMessage, { name: "entidad" })
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_143, [
                            _createElementVNode("label", _hoisted_144, _toDisplayString(_ctx.$t("formularios.inscripcion.puesto.label")), 1),
                            _createElementVNode("div", _hoisted_145, [
                              _createElementVNode("div", _hoisted_146, [
                                _createElementVNode("div", _hoisted_147, [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    name: "puesto",
                                    placeholder: " ",
                                    modelValue: _ctx.puesto,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.puesto) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_148, [
                                    _createElementVNode("div", _hoisted_149, [
                                      _createVNode(_component_ErrorMessage, { name: "puesto" })
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_150, [
                            _createElementVNode("label", _hoisted_151, _toDisplayString(_ctx.$t("formularios.inscripcion.sectorEmpresa.label")), 1),
                            _createElementVNode("div", _hoisted_152, [
                              _createElementVNode("div", _hoisted_153, [
                                _createElementVNode("div", _hoisted_154, [
                                  _createVNode(_component_el_select_v2, {
                                    modelValue: _ctx.sectorEmpresa,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.sectorEmpresa) = $event)),
                                    name: "sectorEmpresa",
                                    class: "w-100",
                                    options: _ctx.sectoresProfesionalesTodos,
                                    placeholder: 
                        _ctx.$t('listados.inscripcionDetalle.seleccionaUno')
                      ,
                                    filterable: ""
                                  }, null, 8, ["modelValue", "options", "placeholder"]),
                                  _createElementVNode("div", _hoisted_155, [
                                    _createElementVNode("div", _hoisted_156, [
                                      _createVNode(_component_ErrorMessage, { name: "sectorEmpresa" })
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_157, [
                      _createElementVNode("label", _hoisted_158, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.nombre.label")), 1),
                      _createElementVNode("div", _hoisted_159, [
                        _createElementVNode("div", _hoisted_160, [
                          _createElementVNode("div", _hoisted_161, [
                            _createVNode(_component_el_input, {
                              type: "text",
                              name: "nombre",
                              placeholder: " ",
                              modelValue: _ctx.nombre,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.nombre) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_162, [
                              _createElementVNode("div", _hoisted_163, [
                                _createVNode(_component_ErrorMessage, { name: "nombre" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_164, [
                      _createElementVNode("label", _hoisted_165, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.apellidos.label")), 1),
                      _createElementVNode("div", _hoisted_166, [
                        _createElementVNode("div", _hoisted_167, [
                          _createElementVNode("div", _hoisted_168, [
                            _createVNode(_component_el_input, {
                              type: "text",
                              name: "apellidos",
                              placeholder: " ",
                              modelValue: _ctx.apellidos,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.apellidos) = $event)),
                              onBlur: _cache[12] || (_cache[12] = ($event: any) => (_ctx.apellidosTouched = true)),
                              onFocus: _cache[13] || (_cache[13] = ($event: any) => (_ctx.apellidosTouched = false))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_169, [
                              _createElementVNode("div", _hoisted_170, [
                                _createVNode(_component_ErrorMessage, { name: "apellidos" })
                              ]),
                              (_ctx.mostrarAvisoApellidos && !_ctx.errors.apellidos)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_171, [
                                    _hoisted_172,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.apellidos.warning")), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_173, [
                      _createElementVNode("label", _hoisted_174, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.dni.label")), 1),
                      _createElementVNode("div", _hoisted_175, [
                        _createElementVNode("div", _hoisted_176, [
                          _createElementVNode("div", _hoisted_177, [
                            _createVNode(_component_el_input, {
                              type: "text",
                              name: "dni",
                              placeholder: " ",
                              modelValue: _ctx.dni,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dni) = $event)),
                              onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.dni = _ctx.dni.toUpperCase()))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_178, [
                              _createElementVNode("div", _hoisted_179, [
                                _createVNode(_component_ErrorMessage, { name: "dni" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_180, [
                      _createElementVNode("label", _hoisted_181, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.email.label")), 1),
                      _createElementVNode("div", _hoisted_182, [
                        _createElementVNode("div", _hoisted_183, [
                          _createElementVNode("div", _hoisted_184, [
                            _createVNode(_component_el_input, {
                              type: "text",
                              name: "email",
                              placeholder: " ",
                              modelValue: _ctx.email,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.email) = $event)),
                              onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.email = _ctx.email.toLowerCase()))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_185, [
                              _createElementVNode("div", _hoisted_186, [
                                _createVNode(_component_ErrorMessage, { name: "email" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_187, [
                      _createElementVNode("label", _hoisted_188, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.telefono.label")), 1),
                      _createElementVNode("div", _hoisted_189, [
                        _createElementVNode("div", _hoisted_190, [
                          _createElementVNode("div", _hoisted_191, [
                            _createVNode(_component_el_input, {
                              type: "tel",
                              name: "telefono",
                              placeholder: " ",
                              modelValue: _ctx.telefono,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.telefono) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_192, [
                              _createElementVNode("div", _hoisted_193, [
                                _createVNode(_component_ErrorMessage, { name: "telefono" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_194, [
                      _createElementVNode("label", _hoisted_195, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.provincia.label")), 1),
                      _createElementVNode("div", _hoisted_196, [
                        _createElementVNode("div", _hoisted_197, [
                          _createElementVNode("div", _hoisted_198, [
                            _createVNode(_component_el_select_v2, {
                              modelValue: _ctx.provincia,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.provincia) = $event)),
                              class: "w-100",
                              options: _ctx.provincias,
                              placeholder: 
                      _ctx.$t('listados.inscripcionDetalle.seleccionaUno')
                    ,
                              onChange: _ctx.updateLocalidades
                            }, null, 8, ["modelValue", "options", "placeholder", "onChange"]),
                            _createElementVNode("div", _hoisted_199, [
                              _createElementVNode("div", _hoisted_200, [
                                _createVNode(_component_ErrorMessage, { name: "provincia" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_201, [
                      _createElementVNode("label", _hoisted_202, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.localidad.label")), 1),
                      _createElementVNode("div", _hoisted_203, [
                        _createElementVNode("div", _hoisted_204, [
                          _createElementVNode("div", _hoisted_205, [
                            _createVNode(_component_el_select_v2, {
                              modelValue: _ctx.localidad,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.localidad) = $event)),
                              name: "localidad",
                              class: "w-100",
                              options: _ctx.localidadesFiltradas,
                              placeholder: 
                      _ctx.$t('listados.inscripcionDetalle.seleccionaUno')
                    
                            }, null, 8, ["modelValue", "options", "placeholder"]),
                            _createElementVNode("div", _hoisted_206, [
                              _createElementVNode("div", _hoisted_207, [
                                _createVNode(_component_ErrorMessage, { name: "localidad" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_208, [
                      _createElementVNode("label", _hoisted_209, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.codigoPostal.label")), 1),
                      _createElementVNode("div", _hoisted_210, [
                        _createElementVNode("div", _hoisted_211, [
                          _createElementVNode("div", _hoisted_212, [
                            _createVNode(_component_el_input, {
                              type: "tel",
                              name: "codigoPostal",
                              placeholder: " ",
                              modelValue: _ctx.codigoPostal,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.codigoPostal) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_213, [
                              _createElementVNode("div", _hoisted_214, [
                                _createVNode(_component_ErrorMessage, { name: "codigoPostal" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    false
                      ? (_openBlock(), _createElementBlock("div", _hoisted_215, [
                          _createVNode(_component_BIconEasel, {
                            style: {"font-size":"1.5rem"},
                            class: "me-3 my-5 mb-6"
                          }),
                          _createTextVNode(_toDisplayString(_ctx.$t("formularios.inscripcion.preferenciasAsistencia.label")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_216, [
                      _createElementVNode("label", _hoisted_217, _toDisplayString(_ctx.$t("formularios.inscripcionDetalle.modalidad.label")), 1),
                      (_ctx.datosCurso.presencial && _ctx.datosCurso.videoconferencia)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
                            _createVNode(_component_el_radio_group, {
                              modelValue: _ctx.modalidad,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.modalidad) = $event)),
                              class: "ml-4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio, {
                                  label: "VIDEOCONFERENCIA",
                                  size: "large"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("formularios.inscripcion.modalidadVideoconferencia.label")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio, {
                                  label: "PRESENCIAL",
                                  size: "large"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("formularios.inscripcion.modalidadPresencial.label")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "presencial",
                              class: "fv-plugins-message-container invalid-feedback"
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_219, _toDisplayString(_ctx.datosCurso.videoconferencia
                  ? _ctx.$t(
                      "formularios.inscripcion.modalidadVideoconferencia.label"
                    )
                  : _ctx.$t("formularios.inscripcion.modalidadPresencial.label")), 1))
                    ]),
                    (_ctx.perfil === 'EMPRENDEDORA')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_220, [
                          _createElementVNode("label", _hoisted_221, _toDisplayString(_ctx.$t("formularios.inscripcion.sectorEmpresa.label")), 1),
                          _createElementVNode("div", _hoisted_222, [
                            _createElementVNode("div", _hoisted_223, [
                              _createElementVNode("div", _hoisted_224, [
                                _createVNode(_component_el_select_v2, {
                                  modelValue: _ctx.sectorEmpresa,
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.sectorEmpresa) = $event)),
                                  name: "sectorEmpresa",
                                  class: "w-100",
                                  options: _ctx.sectoresTodos,
                                  placeholder: 
                      _ctx.$t('listados.inscripcionDetalle.seleccionaUno')
                    
                                }, null, 8, ["modelValue", "options", "placeholder"]),
                                _createElementVNode("div", _hoisted_225, [
                                  _createElementVNode("div", _hoisted_226, [
                                    _createVNode(_component_ErrorMessage, { name: "sectorEmpresa" })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.cursoEmprendimiento)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_227, [
                          _createElementVNode("label", _hoisted_228, _toDisplayString(_ctx.$t(
                  "formularios.inscripcionDetalle.proyectoEmprendimiento.label"
                )), 1),
                          _createElementVNode("div", _hoisted_229, [
                            _createElementVNode("div", _hoisted_230, [
                              _createElementVNode("div", _hoisted_231, [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.proyectoEmprendimiento,
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.proyectoEmprendimiento) = $event)),
                                  width: "100%",
                                  autosize: { minRows: 2, maxRows: 4 },
                                  type: "textarea",
                                  maxlength: "300",
                                  placeholder: 
                      _ctx.$t(
                        'formularios.inscripcionDetalle.proyectoEmprendimiento.placeholder'
                      )
                    
                                }, null, 8, ["modelValue", "placeholder"]),
                                _createVNode(_component_ErrorMessage, {
                                  name: "proyectoEmprendimiento",
                                  class: "fv-plugins-message-container invalid-feedback"
                                })
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_232, [
                      _hoisted_233,
                      _createElementVNode("div", _hoisted_234, [
                        _withDirectives(_createElementVNode("input", {
                          name: "politicaPrivacidad",
                          class: "form-check-input form-control form-control-solid",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.politicaPrivacidad) = $event)),
                          id: "politicaPrivacidad"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.politicaPrivacidad]
                        ]),
                        _createElementVNode("label", _hoisted_235, [
                          _createTextVNode(_toDisplayString(_ctx.$t("aceptacion")) + " ", 1),
                          _createElementVNode("button", _hoisted_236, _toDisplayString(_ctx.$t("PoliticaPrivacidad")), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_237, [
                      _createElementVNode("div", _hoisted_238, [
                        _createVNode(_component_ErrorMessage, {
                          name: "politicaPrivacidad",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_239, [
                      _createElementVNode("div", _hoisted_240, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _ctx.guardar,
                          loading: _ctx.crearInscripcion
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("inscripcionGuardar")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick", "loading"])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])),
    _createVNode(_component_CondicionesPrivacidadModal, { id: "condiciones-privacidad" })
  ], 64))
}